<script lang="ts">
  import DigitalTemplateEditor from "../../_shared/_modules/digital-template-editor"
  import type { TemplatePageProps } from "../../_shared/_logic/announcement-templates-types"
  import { pageConfig } from "./config"

  const { organizationId, policy, canManage, activeTab, onPolicyUpdated }: TemplatePageProps =
    $props()
  const purpose = $derived(
    pageConfig.tabs?.find((tab) => tab.id === activeTab)?.id.slice("phone-".length) ?? null,
  )
</script>

{#if purpose}
  <DigitalTemplateEditor
    {organizationId}
    {policy}
    {canManage}
    {onPolicyUpdated}
    channel="phone"
    {purpose}
  />
{/if}
